import axiosInstance from "../../services/axios";
import { ActionTypes } from "../type";

export const submitNewRegistration = (formData) => async (dispatch) => {
  try {
    const { data } = await axiosInstance.post(
      `LIS/new/registration`,
      formData
    );

    dispatch({
      type: ActionTypes.SUBMIT_NEW_REGISTRATION,
      payload: data,
    });

    return { success: true, data };
  } catch (err) {
    console.error("API Error:", err);

    let errorMessage = "Something went wrong.";

    if (Array.isArray(err?.response?.data?.detail)) {
      errorMessage = err.response.data.detail
        .map((e) => {
          const fieldName = e.loc[e.loc.length - 1]
            .replace(/_/g, " ")
            .replace(/\b\w/g, (c) => c.toUpperCase());

          return `${fieldName}: ${e.msg}`;
        })
        .join("\n");
    } else if (typeof err?.response?.data?.detail === "string") {
      errorMessage = err.response.data.detail;
    }

    dispatch({
      type: ActionTypes.SUBMIT_NEW_REGISTRATION,
      payload: { error: errorMessage },
    });

    throw new Error(errorMessage);
  }
};

export const clearNewRegistration = () => async (dispatch) => {
  try {
    dispatch({
      type: ActionTypes.ClEAR_NEW_REGISTRATION,
    });
  } catch (err) {
    // throw err;
  }
};

export const deleteNewRegistration = (formData) => async (dispatch) => {
  console.log("formDAta", formData);
  try {
    const { data } = await axiosInstance.delete(
      `LIS/new/registration/delete_investigations`,
      { data: formData }
    );
    dispatch({
      type: ActionTypes.DELETE_NEW_REGISTRATION,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: ActionTypes.DELETE_NEW_REGISTRATION,
      payload: { error: "Something weng wrong." },
    });
  }
};

export const deletePackageNewRegistration = (formData) => async (dispatch) => {
  try {
    const { data } = await axiosInstance.delete(
      `LIS/new/registration/delete_packages`,
      { data: formData }
    );
    dispatch({
      type: ActionTypes.DELETE_PACKAGE_NEW_REGISTRATION,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: ActionTypes.DELETE_PACKAGE_NEW_REGISTRATION,
      payload: { error: "Something weng wrong." },
    });
  }
};
